import { forwardRef } from "react";
import "./v2-question-surface.css";

const TextInput = forwardRef(function TextInput(
  { value, variant = "centered", multiline = false, error, rows, ...props },
  ref
) {
  const className = `tgc-v2-text-input tgc-v2-text-input--${variant}${multiline ? " tgc-v2-text-input--multiline" : ""}`;
  const sharedProps = {
    ...props,
    ref,
    className,
    value,
    "data-filled": Boolean(String(value || "").trim()),
    "aria-invalid": error ? "true" : "false",
  };

  if (multiline) {
    return <textarea {...sharedProps} aria-multiline="true" rows={rows} />;
  }

  return <input {...sharedProps} />;
});

export default TextInput;
